export const dateFormat = (date) => {
  const d = new Date(date);
  const dformat =
    [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
    " " +
    [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
  return dformat;
};

export const mobileDevice = () => {
  return (
    Math.min(window.screen.width, window.screen.height) <= 812 ||
    navigator.userAgent.indexOf("Mobi") > -1
  );
};
